import React from 'react'
import styles from "./RecomendationText.module.scss";

const RecomendationText = ({recommendedSize,isOnboadedTryon}) => {
  return (
    <>
     <span  className={styles.swanCtaMainText}>
            <span  className={styles.swanCtaMainText__text}>Swan suggests:</span>
            <span  className={styles.swanCtaMainText__textBlue} >{recommendedSize}</span>
            <span  className={styles.swanCtaMainText__bgText} >{isOnboadedTryon ? "Try-On" : "Fit Notes"}</span>
          </span>
    </>
  )
}

export default RecomendationText